import { u } from '../theming-core'
import theme from 'styled-theming'
import styled, { css, keyframes, withTheme, injectGlobal } from 'styled-components'
import { normalize } from 'polished'
import AppTheme from './AppTheme'

export { u, theme, styled, css, keyframes, withTheme, normalize, injectGlobal }
export default AppTheme
